(() => {
  const initialize = (root) => {
    if (!root || root.dataset.skyHomeReady === 'true') return;
    root.dataset.skyHomeReady = 'true';

    const input = root.querySelector('[data-sky-search-input]');
    const results = root.querySelector('[data-sky-search-results]');
    const dataNode = root.querySelector('[data-sky-search-data]');
    if (!input || !results || !dataNode) return;

    let products = [];
    try { products = JSON.parse(dataNode.textContent); } catch (error) { return; }

    const closeResults = () => { results.hidden = true; results.innerHTML = ''; };
    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    };
    const normalizedUrl = (url) => {
      try { return new URL(url, window.location.origin).pathname; } catch (error) { return url; }
    };
    const formatApiPrice = (price) => {
      const amount = Number(price);
      if (!Number.isFinite(amount)) return '';
      const currency = window.Shopify?.currency?.active || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount); }
      catch (error) { return `${amount.toFixed(2)} ${currency}`; }
    };
    const renderMatches = (matches) => {
      if (!matches.length) { closeResults(); return; }
      results.innerHTML = matches.slice(0, 6).map((product) =>
        `<a class="sky-home-search__result" href="${escapeHtml(product.url)}"><strong>${escapeHtml(product.title)}</strong><small>${product.price ? `From ${escapeHtml(product.price)}` : 'View plans'}</small></a>`
      ).join('');
      results.hidden = false;
    };

    let requestController;
    const renderResults = async () => {
      const query = input.value.trim().toLowerCase();
      if (!query) { closeResults(); return; }
      const mappedMatches = products.filter((product) =>
        `${product.title} ${product.keywords || ''}`.toLowerCase().includes(query)
      );

      if (requestController) requestController.abort();
      requestController = new AbortController();
      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const endpoint = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;
        const response = await fetch(endpoint, { signal: requestController.signal });
        if (!response.ok) throw new Error('Predictive search unavailable');
        const data = await response.json();
        const apiMatches = (data.resources?.results?.products || []).map((product) => ({
          title: product.title,
          url: product.url,
          price: formatApiPrice(product.price_min || product.price)
        }));
        const merged = [...mappedMatches, ...apiMatches].filter((product, index, list) =>
          index === list.findIndex((item) => normalizedUrl(item.url) === normalizedUrl(product.url))
        );
        renderMatches(merged);
      } catch (error) {
        if (error.name !== 'AbortError') renderMatches(mappedMatches);
      }
    };

    input.addEventListener('input', renderResults);
    input.addEventListener('focus', renderResults);
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) closeResults(); });
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeResults(); });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-sky-home]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
